module.exports = __webpack_public_path__ + "84d5fd01536fbaeb4396f5fbdba3c550.png";